<div class="position-relative h-100">
    <div class="modal-header">
        <h4 class="modal-title pull-left">
            @if (isThread) {
                <span translate>Forward the ticket</span>
            } @else {
                <span translate>Forward message</span>
            }
        </h4>
        @if (!isForwardingInNewTab) {
            <div>
                @if (isFormReady) {
                    <button
                        class="btn btn-icon"
                        type="button"
                        (click)="openFormInNewWindow()"
                        [tooltip]="'In new window' | translate"
                        placement="bottom">
                        <sb-inline-svg
                            class="icon"
                            aria-label="My icon"
                            [url]="'/sb-tools/theme/images/icons/external-link-icon.svg'">
                        </sb-inline-svg>
                    </button>
                }
                <button
                    type="button"
                    class="btn btn-icon btn-close btn-transparent"
                    aria-label="Close"
                    (click)="modalRef.hide()">
                    <sb-inline-svg
                        class="icon icon-close"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                    </sb-inline-svg>
                </button>
            </div>
        }
    </div>
    <div class="modal-body" tabindex="-1" id="modalContainer">
        @if (step === 1) {
            @if (!isFormReady) {
                <sb-loader></sb-loader>
            } @else {
                <div class="container forward-form mt-3">
                    <div class="forward-form-wrapper">
                        <app-form-component
                            [form]="form"
                            [formType]="formTypesEnum.inboxForwardForm"
                            [isFormFieldsWithRules]="false"
                            [attachmentsBlockTemplate]="attachmentsBlock"
                            [attachments]="messageData.attachments">
                        </app-form-component>
                    </div>

                    <ng-template #attachmentsBlock>
                        <button
                            class="btn btn-icon btn-attachment float-end"
                            (click)="openAttachmentsModal()"
                            type="button"
                            tooltip="{{ 'Attachments' | translate }}"
                            container="body">
                            <sb-inline-svg
                                class="icon"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                            </sb-inline-svg>
                        </button>
                        <div class="clearfix"></div>

                        <div class="content-attachments-wrapper">
                            @for (
                                attachment of messageData.attachments
                                    | filterContentAttachments: true : messageData.attachments.length;
                                track attachment.id
                            ) {
                                <div class="content-attachments-block">
                                    <button
                                        type="button"
                                        class="btn btn-icon btn-close btn-transparent"
                                        aria-label="Close"
                                        (click)="deleteGifAttachment(attachment)">
                                        <sb-inline-svg
                                            class="icon icon-close"
                                            aria-label="My icon"
                                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                                        </sb-inline-svg>
                                    </button>
                                    <sb-file-view
                                        [isFilePreviewInModal]="!isForwardAttachmentOnly"
                                        [attachment]="attachment"
                                        [permalink]="currentTicket.permalink">
                                    </sb-file-view>
                                    <!--                                    todo: check these ugly ttoltips-->
                                    @if (attachment.attachmentType !== attachmentTypeEnum.carousel) {
                                        <span
                                            class="attachment-name text-break"
                                            tooltip="{{
                                                (attachment.name || attachment.url).length > 80
                                                    ? attachment.name || attachment.url
                                                    : ''
                                            }}">
                                            {{
                                                (attachment.name || attachment.url).length > 80
                                                    ? (attachment.name || attachment.url | slice: 0 : 80) + '...'
                                                    : attachment.name || attachment.url
                                            }}</span
                                        >
                                    }
                                </div>
                            }
                        </div>

                        <div class="attachments-block">
                            @for (attachment of messageData.attachments; track attachment.id; let idx = $index) {
                                @if (!attachment.isContentPart) {
                                    <sb-file-preview
                                        class="file-container"
                                        [isFileNameWithTooltip]="true"
                                        [isRemoveFromServer]="false"
                                        [isPreventPreviewInModal]="isForwardAttachmentOnly"
                                        [attachment]="attachment"
                                        [fileIndex]="idx"
                                        [canBeRemoved]="true"
                                        [permalink]="currentTicket.permalink"
                                        [attachments]="messageData.attachments">
                                    </sb-file-preview>
                                }
                            }
                            <div class="clearfix"></div>
                        </div>
                    </ng-template>
                </div>
            }
        } @else if (step === 2) {
            <div class="d-flex align-items-start feedback-wrapper mt-4">
                <sb-inline-svg
                    class="icon check-icon me-2"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                </sb-inline-svg>
                <div class="ms-2">
                    <p class="mb-2" translate>The ticket was successfully created</p>
                    <a class="link" [href]="newTicketLink" target="_blank" translate> View in inbox >> </a>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer justify-content-between">
        @if (step === 1) {
            <div class="d-flex align-items-center">
                <label
                    class="checkbox__label checkbox__label--size-small min-width-50 ms-3 me-3"
                    for="isAssignedToCreator">
                    {{ 'Assign to me' | translate }}
                    <input
                        type="checkbox"
                        id="isAssignedToCreator"
                        name="isAssignedToCreator"
                        [(ngModel)]="isAssignedToCreator" />
                    <span class="checkbox__checkmark"></span>
                </label>
            </div>
            <div>
                <button type="button" class="btn btn-default btn-outline me-2" (click)="cancel()" translate>
                    Cancel
                </button>

                @if (!commonDataService.customerSettings.isCustomerReplyPortalEnabled) {
                    <button
                        [disabled]="isSaving || !isFormReady"
                        type="button"
                        class="btn btn-primary"
                        (click)="send(false, false)"
                        translate>
                        Send
                    </button>
                    <button
                        [disabled]="isSaving || !isFormReady"
                        type="button"
                        class="btn btn-primary"
                        container="body"
                        tooltip="{{ 'Close new ticket after creation' | translate }}"
                        (click)="send(true, false)"
                        translate>
                        Send and close
                    </button>
                } @else {
                    <div dropdown class="btn-group" [isDisabled]="isSaving || !isFormReady" [dropup]="true">
                        <button
                            [disabled]="isSaving || !isFormReady"
                            type="button"
                            class="btn btn-primary"
                            (click)="send(false, false)"
                            translate>
                            Send
                        </button>
                        <button
                            dropdownToggle
                            type="button"
                            class="btn btn-primary dropdown-toggle dropdown-toggle-split"></button>

                        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right reply-link-block">
                            <li>
                                <button type="button" class="btn icon-padding" (click)="send(true, false)" translate>
                                    Send and close
                                </button>
                            </li>
                            <li>
                                <button type="button" class="btn reply-link" (click)="send(false, true)" translate>
                                    <sb-inline-svg
                                        class="icon ps-0"
                                        aria-label="Link icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                    </sb-inline-svg>
                                    <span translate>Send reply-link</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" class="btn reply-link" (click)="send(true, true)" translate>
                                    <sb-inline-svg
                                        class="icon ps-0"
                                        aria-label="Link icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                    </sb-inline-svg>
                                    <span translate>Send reply-link and close</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                }
            </div>
        } @else if (step === 2) {
            <button type="button" class="btn btn-default" (click)="backToForm()" translate>Back to form</button>

            <button
                type="button"
                class="btn btn-primary"
                ngxClipboard
                [cbContent]="newTicketLink"
                [tooltip]="'Copied' | translate"
                [tooltipFadeDuration]="1000"
                [triggers]="''"
                container="body"
                #ticketLinkTooltip="bs-tooltip"
                (click)="ticketLinkTooltip.show(); ticketLinkTooltip.hide()"
                translate>
                Copy ticket link to clipboard
            </button>
        }
    </div>
</div>
@if (
    isNeedSecondBackdrop ||
    formCommonDataService.isReplyTemplatesModalOpened ||
    assignCategoryAndTagsService.isModalWindowOpen
) {
    <bs-modal-backdrop class="modal-backdrop in show"></bs-modal-backdrop>
}
<ng-template #notification>
    <div class="sn-title" translate>Success!</div>
    <div class="sn-content">
        <span translate>New ticket was successfully created. Click</span>&nbsp;
        <a [routerLink]="['/', commonDataService.communityName, 'tickets']" [queryParams]="{ ticketId }" translate
            >here</a
        >&nbsp;
        <span translate>to view it.</span>
    </div>
</ng-template>
